// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3cfa798e","453":"9df45548","455":"dfffd5e1"}[chunkId] + ".chunk.js";
};